import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'about',
    component: () => import(/* webpackChunkName: "home" */ '../views/about.vue'),
    meta: {
      alive: true
    }
  },
   {
    path: '/laboratory',
    name: 'laboratory',
    component: () => import(/* webpackChunkName: "laboratory" */ '../views/laboratory.vue'),
    meta: {
      alive: true
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/contact.vue'),
    meta: {
      alive: true
    }
  },
  {
    path: '/report',
    name: 'report',
    component: () => import(/* webpackChunkName: "report" */ '../views/report.vue'),
    meta: {
      alive: true
    }
  },
   {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "product" */ '../views/product.vue'),
    meta: {
      alive: true
    }
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import(/* webpackChunkName: "setting" */ '../views/checkout.vue'),
    meta: {
      alive: true
    }
  },
 {
    path: '/payment',
    name: 'payment',
    component: () => import(/* webpackChunkName: "payment" */ '../views/payment.vue'),
    meta: {
      alive: true
    }
  },
   {
    path: '/getmoney',
    name: 'getmoney',
    component: () => import(/* webpackChunkName: "getmoney" */ '../views/getmoney.vue'),
    meta: {
      alive: true
    }
  },



]


// 捕获push replace中的错误
// 当然在replace中的错误也是可以相同的进行捕获
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}


const router = new VueRouter({
  // mode: 'hash',
  // mode: 'history',
  mode: process.env.NODE_ENV === 'development' ? 'hash' : 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }), //滚动到顶端
  routes
})

export default router
